import { Icon } from "@iconify/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { FormWrapper, SubmitButton } from "../../components";
import { allowedFileTypes, UploadFileTypes } from "../../constants";
import { useUpload } from "../../hooks";
import ModalWrapper from "./Modal";
import styles from "./Modal.module.css";

function FileUploadModal({ handleClose, isVisible, fileType, handleUpload }) {
  const [newFile, setNewFile] = useState(null);
  const { uploadFile } = useUpload();
  const [fileUploadStatus, setFileUploadStatus] = useState(false);

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!newFile) {
      toast.error("Please select a file to upload.");
      return;
    }
    setFileUploadStatus(true);

    if (newFile.size > 10 * 1024 * 1024) {
      toast.error("File size must be less than 10MB.");
      return;
    }

    const { success, data, error } = await uploadFile(newFile, fileType);
    setFileUploadStatus(false);
    if (error) return toast.error(error);
    toast.success(success);
    handleUpload(data.file_id, data.url);
    handleClose();
  };

  const handleFileAdd = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      const allowed = allowedFileTypes[fileType] || [];
      const allowedTypesMessage = `The allowed types are ${
        fileType === UploadFileTypes.IMAGES
          ? "jpeg, png"
          : fileType === UploadFileTypes.DOCUMENTS
          ? "pdf, docx"
          : "mp4, mkv"
      }.`;

      if (!allowed.includes(selectedFile.type)) {
        toast.error("Invalid file type. " + allowedTypesMessage);
        return;
      }
      setNewFile(selectedFile);
    }
  };

  return (
    <ModalWrapper isVisible={isVisible} onClose={handleClose} name={"file_upload_modal"} level={2} fit>
      <FormWrapper id="file_upload_form" title="File Upload" onSubmit={handleFileUpload} centerContent>
        {newFile ? (
          <Link to={URL.createObjectURL(newFile)} target="_blank" className={styles.uploaded_file}>
            {newFile.name}
          </Link>
        ) : (
          <div className={styles.upload_input_wrapper}>
            <Icon icon="iconamoon:file-add-thin" className={styles.upload_icon} />
          </div>
        )}
        <div>
          <label htmlFor="new_file" className={styles.upload_link}>
            Browse
            <input
              type="file"
              id="new_file"
              name="new_file"
              accept={
                fileType === UploadFileTypes.DOCUMENTS
                  ? "application/pdf, application/docx"
                  : fileType === UploadFileTypes.IMAGES
                  ? "image/jpeg, image/png"
                  : "video/mp4, video/mkv"
              }
              onChange={handleFileAdd}
              disabled={fileUploadStatus}
              hidden
            />
          </label>
          <span> your files</span>
        </div>
        <SubmitButton form="file_upload_form" isUpload disabled={fileUploadStatus}>
          Upload
        </SubmitButton>
      </FormWrapper>
    </ModalWrapper>
  );
}

export default FileUploadModal;
